export const annotationAsianCopy = {
  it: [
    'Seleziona',
    'Freccia',
    'Linea',
    'Testo con puntatore',
    'Rettangolo',
    'Ellisse',
    'Penna',
    'Evidenziatore',
    'Numero',
    'Oscura',
    'Pixelizza',
    'Riflettore',
    'Lente',
    'Righello',
    'Inserisci immagine',
    'Scegli colore',
    'Annota',
    'Invia alla chat',
    'Annulla',
    'Ripeti',
    'Elimina',
    'Colore',
    'Spessore',
    'Dimensione testo',
    'Riempi',
    'Testo o misura',
    'Ingrandisci',
    'Riduci',
    'Adatta immagine',
    'Impossibile preparare le annotazioni. Riprova.',
    'Caricamento immagine…',
    'Applica le modifiche indicate dalle annotazioni. Considera tutti i segni come istruzioni e rimuovili dal risultato. Conserva le aree oscurate e i dettagli non menzionati.',
    'Annotazioni aggiunte alla chat.',
    'Annulla annotazione',
  ],
  de: [
    'Auswählen',
    'Pfeil',
    'Linie',
    'Text mit Zeiger',
    'Rechteck',
    'Ellipse',
    'Stift',
    'Textmarker',
    'Nummer',
    'Schwärzen',
    'Verpixeln',
    'Spotlight',
    'Lupe',
    'Lineal',
    'Bild einfügen',
    'Farbe aufnehmen',
    'Annotieren',
    'An Chat senden',
    'Rückgängig',
    'Wiederholen',
    'Löschen',
    'Farbe',
    'Strichbreite',
    'Textgröße',
    'Füllen',
    'Text oder Maßangabe',
    'Vergrößern',
    'Verkleinern',
    'Bild einpassen',
    'Anmerkungen konnten nicht vorbereitet werden. Erneut versuchen.',
    'Bild wird geladen…',
    'Wende die markierten Änderungen an. Behandle alle Markierungen als Anweisungen und entferne sie aus dem Ergebnis. Bewahre verdeckte Bereiche und nicht erwähnte Details.',
    'Anmerkungen zum Chat hinzugefügt.',
    'Anmerkung abbrechen',
  ],
  ko: [
    '선택',
    '화살표',
    '선',
    '포인터가 있는 텍스트',
    '사각형',
    '타원',
    '펜',
    '형광펜',
    '번호',
    '가리기',
    '픽셀화',
    '강조 영역',
    '돋보기',
    '눈금자',
    '이미지 삽입',
    '색 추출',
    '주석',
    '채팅에 보내기',
    '실행 취소',
    '다시 실행',
    '삭제',
    '색상',
    '선 두께',
    '글자 크기',
    '도형 채우기',
    '텍스트 또는 치수',
    '확대',
    '축소',
    '이미지 맞춤',
    '주석을 준비하지 못했습니다. 다시 시도하세요.',
    '이미지 로딩 중…',
    '주석에 표시된 변경 사항을 적용하세요. 모든 표시를 지시로 취급하고 결과에서 제거하세요. 가려진 영역과 언급하지 않은 세부 사항은 유지하세요.',
    '채팅에 주석을 추가했습니다.',
    '주석 취소',
  ],
  ja: [
    '選択',
    '矢印',
    '線',
    'ポインター付きテキスト',
    '長方形',
    '楕円',
    'ペン',
    '蛍光ペン',
    '番号',
    '墨消し',
    'ピクセル化',
    'スポットライト',
    '拡大鏡',
    '定規',
    '画像を挿入',
    '色を取得',
    '注釈',
    'チャットに送る',
    '元に戻す',
    'やり直す',
    '削除',
    '色',
    '線の太さ',
    '文字サイズ',
    '塗りつぶし',
    'テキストまたは寸法',
    '拡大',
    '縮小',
    '画像に合わせる',
    '注釈を準備できませんでした。再試行してください。',
    '画像を読み込み中…',
    '注釈で示された変更を適用してください。すべてのマークを指示として扱い、結果から取り除いてください。隠された領域と指定のない細部は保持してください。',
    'チャットに注釈を追加しました。',
    '注釈をキャンセル',
  ],
  hi: [
    'चुनें',
    'तीर',
    'रेखा',
    'सूचक वाला पाठ',
    'आयत',
    'दीर्घवृत्त',
    'पेन',
    'हाइलाइटर',
    'संख्या',
    'छिपाएँ',
    'पिक्सेलेट',
    'स्पॉटलाइट',
    'आवर्धक',
    'रूलर',
    'चित्र डालें',
    'रंग चुनें',
    'टिप्पणी करें',
    'चैट में भेजें',
    'पूर्ववत',
    'फिर करें',
    'हटाएँ',
    'रंग',
    'रेखा की चौड़ाई',
    'पाठ का आकार',
    'आकृति भरें',
    'पाठ या माप लेबल',
    'ज़ूम इन',
    'ज़ूम आउट',
    'चित्र फिट करें',
    'टिप्पणियाँ तैयार नहीं हो सकीं। फिर कोशिश करें।',
    'चित्र लोड हो रहा है…',
    'इन टिप्पणियों में बताए बदलाव लागू करें। सभी निशानों को निर्देश मानें और परिणाम से हटा दें। छिपे क्षेत्रों और जिन विवरणों का उल्लेख नहीं है उन्हें बनाए रखें।',
    'टिप्पणियाँ चैट में जोड़ दी गईं।',
    'एनोटेशन रद्द करें',
  ],
};
